export enum ImagePosition {
  LEFT = 'left',
  RIGHT = 'right',
}
